import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import {
  ApiResponse,
  AdvertisementWithMedia,
  CreateAdvertisement,
  UpdateAdvertisement,
  CreateAdvertisementMedia,
} from '@magnetar/admin-api-interfaces'

export const advertisementService = {
  // 創建廣告
  createAdvertisement: async (data: CreateAdvertisement, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<AdvertisementWithMedia>>(
        `/api/ad-supplier/${data.supplier_id}/advertisements`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'CREATE_ADVERTISEMENT_FAILED',
          message: '建立廣告失敗',
        },
      }
    }
  },

  // 更新廣告
  updateAdvertisement: async (
    supplierId: number,
    advertisementId: number,
    data: UpdateAdvertisement,
    token: string,
  ) => {
    try {
      const response = await apiClient.put<ApiResponse<AdvertisementWithMedia>>(
        `/api/ad-supplier/${supplierId}/advertisements/${advertisementId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_ADVERTISEMENT_FAILED',
          message: '更新廣告失敗',
        },
      }
    }
  },

  // 刪除廣告
  deleteAdvertisement: async (supplierId: number, advertisementId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(
        `/api/ad-supplier/${supplierId}/advertisements/${advertisementId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'DELETE_ADVERTISEMENT_FAILED',
          message: '刪除廣告失敗',
        },
      }
    }
  },

  // 新增廣告媒體
  createAdvertisementMedia: async (
    supplierId: number,
    advertisementId: number,
    data: CreateAdvertisementMedia,
    token: string,
  ) => {
    try {
      const response = await apiClient.post<ApiResponse<AdvertisementWithMedia>>(
        `/api/ad-supplier/${supplierId}/advertisements/${advertisementId}/media`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'CREATE_ADVERTISEMENT_MEDIA_FAILED',
          message: '新增廣告媒體失敗',
        },
      }
    }
  },

  // 刪除廣告媒體
  deleteAdvertisementMedia: async (supplierId: number, mediaId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(
        `/api/ad-supplier/${supplierId}/advertisements/media/${mediaId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'DELETE_ADVERTISEMENT_MEDIA_FAILED',
          message: '刪除廣告媒體失敗',
        },
      }
    }
  },

  // 更新廣告媒體播放時長
  updateAdvertisementMediaDuration: async (
    supplierId: number,
    mediaId: number,
    durationMs: number,
    token: string,
  ) => {
    try {
      const response = await apiClient.put<ApiResponse<AdvertisementWithMedia>>(
        `/api/ad-supplier/${supplierId}/advertisements/media/${mediaId}`,
        { play_duration_ms: durationMs },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_ADVERTISEMENT_MEDIA_DURATION_FAILED',
          message: '更新廣告媒體播放時長失敗',
        },
      }
    }
  },
}
